module.exports = __webpack_public_path__ + "static/new-payments-12c531a756c551193156b52778dfab67.png";